import { ContentResponse } from '../features/content/types/shared';
import { FC, ReactNode } from 'react';
import { useLoaderData } from 'react-router-dom';
import Content from '../features/content/Content';

const ContentRoute: FC = (): ReactNode => {
  const data = useLoaderData() as ContentResponse;

  return (
    <>
      <title>{`${data.name} | KPA Entrésidan`}</title>
      <Content content={data} />
    </>
  );
};

export default ContentRoute;
